let defaultColor;

export const gridStyle = (length, width, percent, color = "#0188cc") => {
    defaultColor = color;

    return {
        display: "grid",
        gridTemplateRow: `repeat(${length - 1}, 35px)`,
        gridTemplateColumns: `repeat(${width}, ${percent}%)`,
        //gridGap: "0.15vh",
        // pageBreakInside: "avoid",
        gridGap: "0.1em",
        backgroundColor: `#0188cc`,
        border: `1px solid ${color} `,
        marginBottom: "10px",
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
    };
};

export const cellStyle = (
    rowIndex,
    columnIndex,
    rowEnd,
    columnEnd,
    fontTrue,
    negative,
    align = "left"
) => {
    let background = "white";
    let color = "black";

    if (negative) {
        background = defaultColor;
        color = "white";
    }
    return {
        gridRowStart: `${rowIndex}`,
        gridRowEnd: `${rowEnd}`,
        gridColumnStart: `${columnIndex}`,
        gridColumnEnd: `${columnEnd}`,
        background: `${background}`,
        borderTopLeftRadius: rowIndex === 1 ? 8 : 0,
        borderTopRightRadius: rowIndex === 1 ? 8 : 0,
        fontFamily: `Arial`,
        flex: 1,
        pageBreakInside: "avoid",
        wordWrap: "break-word",
        overflow: "auto",
        display: "flex",
        color: `${color}`,
        padding: "10px",
        textAlign: align,
    };
};
